import { Card, Input, Row, Select, Spin, Table, Typography } from "antd";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../../../../../components/layouts/MainLayout";
import TopContent from "../../../../../../components/layouts/TopContent";
import { rightAction } from "../../../../../../redux/actions";
import cnt from "../../../../../../services/definedConstant";
import { BOM } from "../../../../../../services/definedMethod";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../../../customer.config";
const { Text } = Typography;

const ManageChequeBookRequest = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { state } = useLocation();
  const navigate = useNavigate();
  const [chequesList, setChequesList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    getCheques();
    BOM.HasPermission("CREATE_CHEQUE") && rightAction(cnt.RIGHT_ADD_BTN);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCheques = () => {
    if (state?.accountNo === undefined || state?.accountNo === null) {
      BOM.AlertMsg(cnt.DANGER, "Account No is required to fetch cheques");
    }

    const url = `${apiConfig.Cheques}?accountNo=${state?.accountNo}`;
    const body = { session };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(
          cnt.DANGER,
          err?.defaultUserMessage || "Failed to fetch cheques",
        );
      } else {
        const objList = res?.pageItems || [];
        let tempArray = [];

        objList.forEach((item) => {
          tempArray.push({
            key: item?.id,
            id: item?.id,
            accountNo: item?.accountNo,
            chequeBookNo: item?.firstChequeNo,
            chequeLeaves: item?.chequeLeaves,
            deliveryMode: item?.deliveryMode,
          });
        });

        setIsLoading(false);
        setChequesList(tempArray);
        setOriginalList(tempArray);
      }
    });
  };

  const columns = [
    {
      title: "Account No",
      dataIndex: "accountNo",
    },
    {
      title: "Cheque Leaves",
      dataIndex: "chequeLeaves",
    },
    {
      title: "Cheque Book No",
      dataIndex: "chequeBookNo",
    },
    {
      title: "Delivery Mode",
      dataIndex: "deliveryMode",
      render: (deliveryMode) =>
        deliveryMode
          ? deliveryMode.charAt(0).toUpperCase() + deliveryMode.slice(1)
          : deliveryMode,
    },
  ];

  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value?.toLowerCase();

    if (!searchKey) {
      setChequesList(originalList);
      return;
    }
    const filterBySearch = originalList.filter(
      (item) =>
        String(item?.accountNo ?? "")
          .toLowerCase()
          .includes(searchKey) ||
        String(item?.chequeBookNo ?? "")
          .toLowerCase()
          .includes(searchKey) ||
        String(item?.chequeLeaves ?? "")
          .toLowerCase()
          .includes(searchKey) ||
        String(item?.deliveryMode ?? "")
          .toLowerCase()
          .includes(searchKey),
    );
    setChequesList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    setSelectedRow(objParam[0]);

    [
      BOM.HasPermission("READ_CHEQUE") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_CHEQUE") && cnt.RIGHT_EDIT_BTN,
    ].forEach((item) => item && dispatch({ type: item }));
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-cheque-book-request", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-cheque-book-request", { state: state });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-cheque-book-request", { state: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  return (
    <MainLayout
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
      isEnableRightSidebar={true}
    >
      <TopContent
        pageTitle={labelConfig.manageChequeBookRequest}
        pageItems={staticConfig.manageChequeBookRequestBreadcrumbItems}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Filter by account no, cheque book no, leaves, or delivery mode..."
                style={{
                  width: 400,
                }}
              />
            </div>
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
              hideSelectAll: true,
            }}
            columns={columns}
            dataSource={chequesList}
            bordered
            pagination={{
              position: ["bottomCenter"],
              pageSize: Number(tableCount),
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ManageChequeBookRequest);
